import { renderCustomComponent } from 'components/ChatWidget';
import BotResponseDrafts from '../BotResponseDrafts';

const DisplayBotResponseDrafts = ({ chatMessage, chatMessageIndex }) => {
    return renderCustomComponent(BotResponseDrafts, {
        drafts: chatMessage.drafts,
        messageIndex: chatMessageIndex
    });
};

export default DisplayBotResponseDrafts;
